module.exports = __webpack_public_path__ + "static/media/escoriacao_erosa.02058d20.jpg";